import {DialogOrchestrator} from "./orchestrator";
import {DIALOG_CONFIGS} from "./config/dialogs.config";

/**
 * App-wide orchestrator instance.
 *
 * A module singleton (lazily created) so non-React callers — websocket
 * handlers, RTK Query `onQueryStarted`, plain timers — can drive dialogs
 * without prop-drilling or hooks:
 *
 *   import {getOrchestrator} from "@/lib/dialog-orchestrator";
 *   getOrchestrator().open(DialogsEnum.FUNDS_CREDITED);
 *
 * The React layer (`DialogOrchestratorProvider`) connects this same instance to
 * the Redux store + router for context input and render output.
 */
let instance: DialogOrchestrator | null = null;

export function getOrchestrator(): DialogOrchestrator {
    if (!instance) {
        instance = new DialogOrchestrator(DIALOG_CONFIGS);
    }
    return instance;
}

/** Test helper: drop the singleton so each test starts clean. */
export function __resetOrchestrator(): void {
    instance = null;
}
